import React from 'react'

import { Icon, Inline, Text } from '@procsea/design-system'

import { useCurrentMembership } from 'src/contexts/userContext'
import { CtaAction, TrackingSource, useTracking } from 'src/hooks'

import { StyledAIButton } from './InvoicingWithAIButton.styles'

const label = gettext('Invoicing with AI')

interface InvoicingWithAIButtonProps {
  source: TrackingSource
  isShortButton?: boolean
}

export const InvoicingWithAIButton = ({
  source,
  isShortButton = false,
}: InvoicingWithAIButtonProps) => {
  const { trackCta } = useTracking({ source })
  const membership = useCurrentMembership()

  const handleClick = () => {
    trackCta({
      action: CtaAction.EXPRESS_INTEREST_IN_INVOICING_WITH_AI,
      label,
    })
  }

  return membership.optInvoicingWithAiPromo && membership.isSeller ? (
    <StyledAIButton
      data-e2e="invoicing-with-ai-button"
      variant="white"
      text
      onClick={handleClick}
      isShortButton={isShortButton}
    >
      <Inline data-e2e="invoicing-with-ai-button-inner" spacing="xsmall" alignment="center" noWrap>
        <Icon name="sparkles" />
        <Text data-e2e="button-text" noWrap>
          {label}
        </Text>
      </Inline>
    </StyledAIButton>
  ) : null
}
